import type { ReactNode } from 'react'
import { Column } from 'src/shared/components/Semantic/all'
import { Footer } from 'src/shared/components/Footer'
import { PageContainer } from 'src/shared/components/PageContainer'

export const CatalogShell = ({
  children,
  embedded = false,
  asSection = false,
  showFooter = true,
  width = 'lg',
}: {
  children: ReactNode
  embedded?: boolean
  asSection?: boolean
  showFooter?: boolean
  width?: 'md' | 'lg'
}) => {
  if (embedded) {
    return <Column className="gap-4 p-3">{children}</Column>
  }

  if (asSection) {
    return <Column className="gap-4">{children}</Column>
  }

  return (
    <>
      <PageContainer width={width} className="gap-6 py-6">
        {children}
      </PageContainer>

      {showFooter && (
        <div className="mt-8">
          <Footer />
        </div>
      )}
    </>
  )
}
